import { forEach } from 'lodash';
import { PaginateListMore } from '../../../common/types/common-types';
import { apiClient, apiErrorHandler } from 'src/app/common/network';
import { Dispatch } from 'react';
import { CandidateManagementReportListParams } from '../types/candidateManagementReportTypes';

const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_ADMIN']}`;
// const ADMIN_URL = `http://localhost:1111`;

const formatDataFilters = (params: CandidateManagementReportListParams) => {
  let data: any = {
    dataFilters: [],
    page: params.page,
    limit: params.limit,
  };
  forEach(params, (param, key) => {
    switch (key) {
      case 'requestedDateFrom':
        data.dataFilters.push({
          name: 'requestedDateFrom',
          value: param,
          type: 'Date',
          operator: 'gt',
        });
        break;
      case 'requestedDateTo':
        data.dataFilters.push({
          name: 'requestedDateTo',
          value: param,
          type: 'Date',
          operator: 'lt',
        });
        break;
      case 'eventName':
        data.dataFilters.push({
          name: 'eventName',
          value: param,
          type: 'string',
          operator: 'search',
        });
        break;
      case 'type':
        data.dataFilters.push({
          name: 'type',
          value: 'candidate',
          type: 'string',
          operator: 'search',
        });
        break;
    }
  });
  return data;
};

export const fetchCandidateManagementReportDownload = (
  params: CandidateManagementReportListParams,
  dispatch?: Dispatch<any>,
): void => {
  params.limit = 999999999;
  const uri = `${ADMIN_URL}/report/event/candidate-report/export`;

  apiClient
    .post<Blob>(uri, params, { responseType: 'text' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob(['\uFEFF' + response.data], { type: 'text/csv;charset=utf-8;' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report-event-candidate' + new Date().toISOString() + '.csv');
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchCandidateManagementReport = async (
  params: CandidateManagementReportListParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateListMore<any>> => {
  const uri = `${ADMIN_URL}/report/event/candidate-report`;

  return apiClient
    .post<PaginateListMore<any>>(uri, params)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
